import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '@components/PrimaryButton';
import { HeaderLayout } from '@layouts';
import { ROUTES } from '@constants';
import { useStyles, useStylesButton } from './styles';
import thankYouOrder from '@assets/thankyou-bg.png';
import { useVisitContext } from '@hooks';

function ThankYouScreen() {
  const { t } = useTranslation(['thankYouScreen', 'button']);
  const classes = useStyles();
  const history = useHistory();
  const classesButton = useStylesButton();
  const { createVisit } = useVisitContext();

  const handleNextPage = async nextScreen => {
    const stringifyPlaceData = localStorage.getItem('place');
    const parsedPlaceData = JSON.parse(stringifyPlaceData);

    await createVisit({
      placeId: parsedPlaceData.placeId,
      tableId: parsedPlaceData.tableId,
    });

    history.push(nextScreen, {
      from: ROUTES.THANK_YOU_SCREEN,
      data: {
        nextScreen,
      },
    });
  };

  return (
    <HeaderLayout>
      <div className={classes.content}>
        <img src={thankYouOrder} alt="emptyOrder" />
        <div className={classes.textMessage}>{t('title')}</div>
        <div className={classes.subTextMessage}>{t('subTitle')}</div>
        <div className={classes.buttonGroup}>
          <PrimaryButton
            text={t('button:cocktailMenu')}
            handleClick={() => handleNextPage(ROUTES.MENU_SCREEN)}
          />
          <p className={classes.buttonSeparator}>{t('or')}</p>
          <PrimaryButton
            classesButton={classesButton}
            text={t('button:cocktailSetup')}
            handleClick={() => handleNextPage(ROUTES.SLIDER_SCREEN)}
          />
        </div>
      </div>
    </HeaderLayout>
  );
}

export default ThankYouScreen;
